import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';

import { withDisplaying } from '../../hoc';

class CustomCheckbox extends PureComponent {
  constructor() {
    super();
    this.setData = this.setData.bind(this);
  }
  setData(e, v) {
    const { setData, path } = this.props;
    setData(path, v);
  }
  render() {
    const { xs, sm, md, lg, xl, label, grid, classGrid,
      CheckboxOnly, ...props } = this.props;
    delete props.setData;
    const input = (CheckboxOnly ?
      <Checkbox color="primary"
        {...props}
        onChange={this.setData}
      /> :
      <FormControlLabel
        style={props.center ? {
          display: 'flex',
          justifyContent: ' center'
        } : null}
        control={
          <Checkbox color="primary"
            {...props}
            onChange={this.setData}
          />
        }
        label={label}
      />
    );
    if (grid) {
      return (
        <Grid
          item
          xs={xs}
          sm={sm}
          md={md}
          lg={lg}
          xl={xl}
          className={classGrid}
        >
          {input}
        </Grid>
      );
    }
    return input;
  }
}


CustomCheckbox.displayName = 'CustomCheckbox';

CustomCheckbox.propTypes = {
  path: PropTypes.arrayOf(PropTypes.string),
  setData: PropTypes.func,
  checked: PropTypes.bool,
  label: PropTypes.string,
  grid: PropTypes.bool,
  classGrid: PropTypes.string,
};

export default withDisplaying()(CustomCheckbox);
